import { Injectable, Injector } from "@angular/core";
import { EndpointFactory } from "../../../services/endpoint-factory.service";
import { HttpHeaders, HttpClient, HttpRequest, HttpParams } from "@angular/common/http";
import { AppTranslationService } from "../../../services/app-translation.service";
import { ConfigurationService } from "../../../services/configuration.service";
import { LocalStoreManager } from "../../../services/local-store-manager.service";
import { DBkeys } from "../../../services/db-Keys";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class HcoService extends EndpointFactory {

  //headers = new HttpHeaders();
  culture: string = "ar";

  constructor(protected http: HttpClient,
    private translateService: AppTranslationService,
    protected configurations: ConfigurationService, injector: Injector,
    private localStorage: LocalStoreManager) {
    super(http, configurations, injector);

    //this.headers = new HttpHeaders({
    //  'Authorization': "Bearer " + this.localStorage.getData(DBkeys.ACCESS_TOKEN),
    //  'Content-Type': "application/json",
    //  'Accept': `application/vnd.iman.v${EndpointFactory.apiVersion}+json, application/json, text/plain, */*`,
    //  'App-Version': ConfigurationService.appVersion,
    //  'Access-Control-Allow-Origin': "*",
    //  'Access-Control-Allow-Methods': "GET,POST,PATCH,PUT,DELETE,OPTIONS",
    //  'Access-Control-Allow-Headers': "Origin, Content-Type, X-Auth-Token"
    //});
    this.culture = this.configurations.language;
  }

  getAll() {
    return this.http.get(this.configurations.apiAddress + "/api/hco/getAll");
  }

  getAllPaged(searchText: string, excludedHcoId: number = 0, pageSize: number = 100, pageNumber: number = 1) {
    let myParams = new HttpParams()
      .set("searchText", searchText === undefined || searchText === null ? "" : searchText)
      .set("excludedHcoId", excludedHcoId.toString())
      .set("pageSize", pageSize.toString())
      .set("pageNumber", pageNumber.toString());
    return this.http.get(this.configurations.apiAddress + "/api/hco/getAllPaged", { params: myParams });
  }

  getAllHCPs() {
    return this.http.get(this.configurations.apiAddress + "/api/hco/getAllHCPs");
  }

  searchHCPsForDropdown(searchText: string, pageSize: number = 100, pageNumber: number = 1) {
    let myParams = new HttpParams()
      .set("searchText", searchText === undefined || searchText === null ? "" : searchText)
      .set("pageSize", pageSize.toString())
      .set("pageNumber", pageNumber.toString());
    return this.http.get(this.configurations.apiAddress + "/api/hco/searchHCPsForDropdown", { params: myParams });
  }

  getHcpById(hcpId: number) {
    return this.http.get(`${this.configurations.apiAddress}/api/hcp/getById/${hcpId}`);
  }

  downloadCsvTemplate(): Observable<Blob> {
    //return this.http.get(this.configurations.apiAddress + '/api/hco/downloadCSVTemplate');
    //let options = new RequestOptions({ responseType: ResponseContentType.Blob });
    return this.http.get(this.configurations.apiAddress + "/api/hco/downloadCSVTemplate", { responseType: "blob" });

  }

  downloadErrorFile(): Observable<Blob> {
    return this.http.get(this.configurations.apiAddress + "/api/hco/downloadErrorFile", { responseType: "blob" });
  }

  uploadCsvTemplate(formData) {
    //const uploadReq = new HttpRequest("POST", this.configurations.apiAddress + `/api/hco/uploadCSVTemplate`, formData, {
    //  reportProgress: true,
    //});
    //return this.http.request(uploadReq);
    return this.http.post(this.configurations.apiAddress + "/api/hco/uploadCSVTemplate", formData);

  }

  updateFromCSV(formData) {
    return this.http.post(this.configurations.apiAddress + "/api/hco/updateFromCSV", formData);
  }

  getUpdateFromCSVStatus(jobId: string) {
    return this.http.get(this.configurations.apiAddress + "/api/hco/updateFromCSV/status/" + jobId);
  }

  addHcoHcps(hcoId: number, hcpIds: number[]) {
    let myParams = new HttpParams()
      .set("hcoId", hcoId.toString())
      .set("hcpIds", hcpIds.join(', '))
    return this.http.get(this.configurations.apiAddress + "/api/hco/addHcoHcps", { params: myParams });
  }

  getHcoHcpsByHcoId(hcoId: number) {
    return this.http.get(this.configurations.apiAddress + "/api/hco/getHcoHcpsByHcoId/" + hcoId);
  }

  addHcpHcos(hcpId: number, hcoIds: number[]) {
    let myParams = new HttpParams()
      .set("hcpId", hcpId.toString())
      .set("hcoIds", hcoIds.join(', '))
    return this.http.get(this.configurations.apiAddress + "/api/hco/addHcpHcos", { params: myParams });
  }

  getHcpHcosByHcpId(hcpId: number) {
    return this.http.get(this.configurations.apiAddress + "/api/hco/getHcpHcosByHcpId/" + hcpId);
  }

  getHcpsByHcoId(hcoId: number) {
    return this.http.get(this.configurations.apiAddress + "/api/hco/getHcpsByHcoId/" + hcoId);
  }

  searchUserHcos(searchText?: string, userId?: number, getLastVisitNote: boolean = false, buId = 0, getNoOfVisistsInMonth: boolean = false) {

    let myParams = new HttpParams()
      .set("searchText", searchText === undefined ? "" : searchText)
      .set("getLastVisitNote", getLastVisitNote.toString())
      .set("userId", userId == null ? "" : userId.toString())
      .set("getNoOfVisistsInMonth", getNoOfVisistsInMonth.toString())
      .set("buId", buId.toString());


    return this.http.get(`${this.configurations.apiAddress}/api/hco/userHcos`, { params: myParams });
  }
  allUserHcos(searchText?: string, userId?: number, pageSize?: number, pageNumber?: number, buId = 0 ,brickId?: number, organizationTypeId?: number) {

    let myParams = new HttpParams()
      .set("searchText", searchText === undefined ? "" : searchText)
      .set("pageSize", pageSize === undefined ? "900000" : pageSize.toString())
      .set("pageNumber", pageNumber === undefined ? "1" : pageNumber.toString())
      .set("buId", buId.toString())
      .set("brickId", brickId == undefined ? "0" : brickId.toString())
      .set("organizationTypeId", organizationTypeId == undefined ? "0" : organizationTypeId.toString())
      .set("userId", userId === undefined ? "" : userId.toString());
    return this.http.get(`${this.configurations.apiAddress}/api/hco/allUserHcos`, { params: myParams });
  }
  alluserHcosTotalCount(searchText?: string, userId?: number, buId = 0) {

    let myParams = new HttpParams()
      .set("searchText", searchText === undefined ? "" : searchText)
      .set("buId", buId.toString())
      .set("userId", userId === undefined ? "" : userId.toString());
    return this.http.get(`${this.configurations.apiAddress}/api/hco/alluserHcosTotalCount`, { params: myParams });
  }

  getPendingApproval(searchText: string, brickId: number, organizationTypeId: number, pageSize: number, pageNumber: number, startDate, endDate, searchedByUserid) {
    let myParams = new HttpParams()
      .set("brickId", brickId == undefined ? "0" : brickId.toString())
      .set("organizationTypeId", organizationTypeId == undefined ? "0" : organizationTypeId.toString())
      .set("searchText", searchText == undefined ? "" : searchText)
      .set('endDate', endDate == undefined ? "" : endDate.toDateString())
      .set('startDate', startDate == undefined ? "" : startDate.toDateString())
      .set("searchedByUserid", searchedByUserid == undefined ? "" : searchedByUserid.toString())
      .set("pageNumber", pageNumber.toString());
    //.set("pageSize", pageSize == undefined?"": pageSize.toString());
    return this.http.get(this.configurations.apiAddress + "/api/hco/pendingApproval", { params: myParams });
  }

  getPendingEditApproval(searchText: string, brickId: number, organizationTypeId: number, pageSize: number, pageNumber: number, startDate, endDate, searchedByUserid) {
    let myParams = new HttpParams()
      .set("brickId", brickId == undefined ? "0" : brickId.toString())
      .set("organizationTypeId", organizationTypeId == undefined ? "0" : organizationTypeId.toString())
      .set("searchText", searchText == undefined ? "" : searchText)
      .set('endDate', endDate == undefined ? "" : endDate.toDateString())
      .set('startDate', startDate == undefined ? "" : startDate.toDateString())
      .set("searchedByUserid", searchedByUserid == undefined ? "" : searchedByUserid.toString())
      .set("pageNumber", pageNumber.toString());

    return this.http.get(this.configurations.apiAddress + "/api/hco/pendingEditApproval", { params: myParams });
  }

  getHcoEditHistory(searchText: string, brickId: number, organizationTypeId: number, pageNumber: number, startDate, endDate, requestedByUserid, status) {
    let myParams = new HttpParams()
      .set("brickId", brickId == undefined ? "0" : brickId.toString())
      .set("organizationTypeId", organizationTypeId == undefined ? "0" : organizationTypeId.toString())
      .set("searchText", searchText == undefined ? "" : searchText)
      .set('endDate', endDate == undefined ? "" : endDate.toDateString())
      .set('startDate', startDate == undefined ? "" : startDate.toDateString())
      .set("requestedByUserid", requestedByUserid == undefined ? "" : requestedByUserid.toString())
      .set("status", status == undefined ? "" : status.toString())
      .set("pageNumber", pageNumber.toString());

    return this.http.get(this.configurations.apiAddress + "/api/hco/editHistory", { params: myParams });
  }

  getHcoEditRequestProposedData(editRequestId: number) {
    return this.http.get(this.configurations.apiAddress + "/api/hco/getEditRequestProposedData/" + editRequestId);
  }

  getHcoEditRequestComparison(editRequestId: number) {
    return this.http.get(this.configurations.apiAddress + "/api/hco/getEditRequestComparison/" + editRequestId);
  }

  approveHcoEditRequest(editRequestId: number) {
    return this.http.post(this.configurations.apiAddress + "/api/hco/approveEditRequest/" + editRequestId, null);
  }

  rejectHcoEditRequest(editRequestId: number) {
    return this.http.post(this.configurations.apiAddress + "/api/hco/rejectEditRequest/" + editRequestId, null);
  }

  filterUserHcos(organizationTypeId: number, brickId: number) {
    let myParams = new HttpParams()
      .set("organizationTypeId", organizationTypeId.toString())
      .set("brickId", brickId.toString());

    return this.http.get(`${this.configurations.apiAddress}/api/hco/filterUserHcos`, { params: myParams });
  }
  deleteHcoHcpsById(id: number) {
    return this.http.delete(this.configurations.apiAddress + "/api/hco/deleteHcoHcpsById/" + id);
  }

  getAllHcosTree() {
    return this.http.get(`${this.configurations.apiAddress}/api/hco/getAllHcosTree`);
  }

  getAllUserHcps(userId?: number) {
    let myParams = new HttpParams()
      .set("userId", userId === undefined ? "" : userId.toString())
    return this.http.get(`${this.configurations.apiAddress}/api/hcp/userHcps`, { params: myParams });
    // return this.http.get(`${this.configurations.apiAddress}/api/hco/getAllUserHcps`, { params: myParams });
  }

  getAllHcosTreeByOrganizationType(organizationTypeId) {
    return this.http.get(`${this.configurations.apiAddress}/api/hco/GetAllHcosTreeByOrganizationType/` + organizationTypeId);
  }

  getHcoDetails(hcoId) {
    return this.http.get(`${this.configurations.apiAddress}/api/hco/getById/${hcoId}`);
  }

  //HCO BusinessUnit Classes
  getHCOBusinessUnitClasses(hcoId, includeHistory: boolean = false) {
    return this.http.get(`${this.configurations.apiAddress}/api/hcoBusinessUnitClass/getAll/${hcoId}?includeHistory=${includeHistory}`);
  }

  deleteHCOBusinessUnitClassById(id) {
    return this.http.delete(`${this.configurations.apiAddress}/api/hcoBusinessUnitClass/deleteById/${id}`);
  }
  saveHCOBusinessUnitClass(hcoBusinessUnitClass) {
    return this.http.post(`${this.configurations.apiAddress}/api/hcoBusinessUnitClass/save`, hcoBusinessUnitClass);
  }

  deleteHCOBusinessUnitClass(hcoId, businessUnitId) {
    return this.http.delete(`${this.configurations.apiAddress}/api/hcoBusinessUnitClass/delete/${hcoId}/${businessUnitId}`);
  }

  getHCOBusinessUnitClassHistory(hcoId, businessUnitId) {
    return this.http.get(`${this.configurations.apiAddress}/api/hcoBusinessUnitClass/getHistory/${hcoId}/${businessUnitId}`);
  }

  GetAllOrganizationType() {
    return this.http.get(`${this.configurations.apiAddress}/api/OrganizationType/getAll`);
  }

  getHcoChilds(parentId) {
    return this.http.get(`${this.configurations.apiAddress}/api/hco/getHcoChilds/${parentId}`);
  }


  downloadHcpHcosCSVTemplate(): Observable<Blob> {
    return this.http.get(this.configurations.apiAddress + "/api/hco/downloadHcpHcosCSVTemplate", { responseType: "blob" });

  }

  downloadHcpHcosErrorFile(): Observable<Blob> {
    return this.http.get(this.configurations.apiAddress + "/api/hco/downloadHcpHcosErrorFile", { responseType: "blob" });
  }

  provisionHcpHcosFromCSV(formData) {
    return this.http.post(this.configurations.apiAddress + "/api/hco/provisionHcpHcosFromCSV", formData);

  }

  downloadMergeHcosIntoHcoCSVTemplate(): Observable<Blob> {
    return this.http.get(this.configurations.apiAddress + "/api/hco/downloadMergeHcosIntoHcoCSVTemplate", { responseType: "blob" });
  }

  downloadMergeHcosIntoHcoErrorFile(): Observable<Blob> {
    return this.http.get(this.configurations.apiAddress + "/api/hco/downloadMergeHcosIntoHcoErrorFile", { responseType: "blob" });
  }

  provisionMergeHcosIntoHco(formData) {
    return this.http.post(this.configurations.apiAddress + "/api/hco/provisionMergeHcosIntoHco", formData);
  }

  getHcoHcpPendingApprovalOrDeleted(startDate, endDate, searchedByUserid, hcpSearch, hcoSearch) {
    let myParams = new HttpParams()
      .set('endDate', endDate == undefined ? "" : endDate.toDateString())
      .set('startDate', startDate == undefined ? "" : startDate.toDateString())
      .set("searchedByUserid", searchedByUserid == undefined ? "" : searchedByUserid.toString())
      .set("hcpSearch", hcpSearch == undefined ? "" : hcpSearch)
      .set("hcoSearch", hcoSearch == undefined ? "" : hcoSearch);
    return this.http.get(this.configurations.apiAddress + "/api/hco/getHcoHcpPendingApprovalOrDeleted", { params: myParams });
  }

  approveAddOrRejectDeleteHcoHcpsById(id: number) {
    return this.http.get(this.configurations.apiAddress + "/api/hco/approveAddOrRejectDeleteHcoHcpsById/" + id);
  }


  reviewAddHcoHcpsById(id: number, approve: boolean) {
    return this.http.get(this.configurations.apiAddress + "/api/hco/reviewAddHcoHcpsById/" + id + "/" + approve);
  }

  reviewDeleteHcoHcpsById(id: number, approve: boolean) {
    return this.http.get(this.configurations.apiAddress + "/api/hco/reviewDeleteHcoHcpsById/" + id + "/" + approve);
  }



  getUserHcoHcpAddingReuqests(startDate, endDate, status, pageNumber, pageSize, searchedByUserid, hcpSearch, hcoSearch) {
    let myParams = new HttpParams()
      .set('endDate', endDate == undefined ? "" : endDate.toDateString())
      .set('startDate', startDate == undefined ? "" : startDate.toDateString())
      .set("status", status == undefined ? "" : status.toString())
      .set("pageNumber", pageNumber.toString())
      .set("searchedByUserid", searchedByUserid == undefined ? "" : searchedByUserid.toString())
      .set("hcpSearch", hcpSearch == undefined ? "" : hcpSearch)
      .set("hcoSearch", hcoSearch == undefined ? "" : hcoSearch)
      .set("pageSize", pageSize.toString());

    return this.http.get(this.configurations.apiAddress + "/api/hco/getUserHcoHcpAddingReuqests", { params: myParams });
  }

  getUserHcoHcpDeletingReuqests(startDate, endDate, status, pageNumber, pageSize, searchedByUserid, hcpSearch, hcoSearch) {
    let myParams = new HttpParams()
      .set('endDate', endDate == undefined ? "" : endDate.toDateString())
      .set('startDate', startDate == undefined ? "" : startDate.toDateString())
      .set("status", status == undefined ? "" : status.toString())
      .set("pageNumber", pageNumber.toString())
      .set("searchedByUserid", searchedByUserid == undefined ? "" : searchedByUserid.toString())
      .set("hcpSearch", hcpSearch == undefined ? "" : hcpSearch)
      .set("hcoSearch", hcoSearch == undefined ? "" : hcoSearch)
      .set("pageSize", pageSize.toString());

    return this.http.get(this.configurations.apiAddress + "/api/hco/getUserHcoHcpDeletingReuqests", { params: myParams });
  }


  getHcoAttachements(hcoId: number) {
    return this.http.get(this.configurations.apiAddress + "/api/hco/getHcoAttachements/" + hcoId);
  }

  saveHcoAttachements(hco) {
    return this.http.post(`${this.configurations.apiAddress}/api/hco/saveHcoAttachements`, hco);
  }

  saveHcoApprovalCycle(hco: any) {
    return this.http.post(this.configurations.apiAddress + "/api/hco/saveHcoApprovalCycle", hco);
  }

  getHcoApprovalCycle() {
    return this.http.get(this.configurations.apiAddress + "/api/hco/getHcoApprovalCycle");
  }

}
